'use strict';

exports.__esModule = true;

var _decorateComponents = require('./decorateComponents');

var _decorateComponents2 = _interopRequireDefault(_decorateComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$child = _ref.child,
      child = _ref$child === undefined ? null : _ref$child,
      _ref$useSandboxMethod = _ref.useSandboxMethods,
      useSandboxMethods = _ref$useSandboxMethod === undefined ? ['loadPerimeter', 'loadModule', 'guard', 'isAllowed', 'isNotAllowed', 'hasPerimeter', 'getPerimeter', 'getPerimeters', 'governess'] : _ref$useSandboxMethod,
      _ref$exposePurpose = _ref.exposePurpose,
      exposePurpose = _ref$exposePurpose === undefined ? true : _ref$exposePurpose;

  (0, _decorateComponents2.default)(Vue, { child: child, useSandboxMethods: useSandboxMethods, exposePurpose: exposePurpose });
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-kindergarten/lib/vue-kindergarten/install.js
// module id = NYUl
// module chunks = 0